__turbopack_context__.v({
  "appButton": "_2gTduW_appButton",
  "comingEyebrow": "_2gTduW_comingEyebrow",
});
